module.exports = __webpack_public_path__ + "c47fbb9a3a3bbdc42b2d7fc85ab089d5.pdf";